import { clsx } from 'clsx'
import { Link } from '@remix-run/react'
import { getLinkType } from '~/utils'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import type { NavItem, SanityCustomImage } from '~/sanity'

interface NavLinkProps extends NavItem {
  className?: string
  hasArrow?: boolean
  onClick?: () => void
  setOpen?: boolean
}

interface NavLinkInnerProps {
  icon?: SanityCustomImage
  title: string
  titleBold?: boolean
  titleHighlight?: boolean
  hasArrow?: boolean
}

const NavLinkInner = ({
  icon,
  title,
  titleBold,
  titleHighlight,
  hasArrow,
}: NavLinkInnerProps) => (
  <>
    <span className="flex items-center">
      {icon?.asset?.url && (
        <img
          src={icon.asset.url}
          alt={icon?.alt}
          className="mr-2 max-w-10"
        />
      )}
      <span
        className={clsx({
          'font-bold': titleBold,
          'text-red-600': titleHighlight,
        })}
      >
        {title}
      </span>
    </span>
    {hasArrow && <ChevronRightIcon className="ml-3 size-4" />}
  </>
)

const NavLink = ({
  icon,
  title,
  titleBold,
  titleHighlight,
  linkType,
  linkSlug,
  linkReference,
  linkExternal,
  className,
  hasArrow,
  onClick,
  setOpen,
}: NavLinkProps) => {
  const link = getLinkType({ linkType, linkReference, linkSlug, linkExternal })

  if (!link && !onClick) return null

  const classes = hasArrow
    ? 'flex justify-between items-center' + ' ' + className
    : className

  return onClick ? (
    <button
      onClick={onClick}
      className={classes}
    >
      <NavLinkInner
        icon={icon}
        title={title}
        titleBold={titleBold}
        titleHighlight={titleHighlight}
        hasArrow={hasArrow}
      />
    </button>
  ) : linkType == 'external' ? (
    <a
      href={link}
      className={classes}
    >
      <NavLinkInner
        icon={icon}
        title={title}
        titleBold={titleBold}
        titleHighlight={titleHighlight}
        hasArrow={hasArrow}
      />
    </a>
  ) : (
    <Link
      to={link}
      className={classes}
    >
      <NavLinkInner
        icon={icon}
        title={title}
        titleBold={titleBold}
        titleHighlight={titleHighlight}
        hasArrow={hasArrow}
      />
    </Link>
  )
}

export default NavLink
